module.exports = __webpack_public_path__ + "img/2.f435e7e2.png";